module.exports = "/_next/static/images/kz-aebe1ef9087c99b2fbb7fbb2b44bc792.svg";